import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizerSettings } from "../../app/features/organizer/organizerSettingsSlice";
import logoFallback from "../../gallery/logo.png";
import { useLocation } from "react-router-dom";
import { BeatLoader } from "react-spinners";

    

require("../../css/navbar.css");
require("../../js/navbar.js");

function EventNavbar() {
  const location = useLocation();
  
  const substrings = location.pathname.split("/");
  const slug = substrings["2"];
  const dispatch = useDispatch();
  const { data: settings, loading } = useSelector(
    (state) => state.organizerSettings
  );

  useEffect(() => {
    dispatch(fetchOrganizerSettings(slug));
  }, [dispatch]);


  const iconColor =
    settings && settings.header_text_color
      ? settings.header_text_color
      : "#ffffff";

  const headerBg =
    settings && settings.header_bg_color ? settings.header_bg_color : "#0040C1";

  const logoSrc =
    settings && settings.logo_url ? settings.logo_url : logoFallback;

  const companyName =
    settings && settings.company_name ? settings.company_name : "Logo";

  return (
    <nav
      className="navbar navbar-expand-lg event-nav-bg sticky-top"
      style={{
        backgroundColor: headerBg,
        color: iconColor,
      }}
    >
      <div className="container d-flex justify-content-between align-items-center">

        <Link to="/" className="navbar-logo d-flex align-items-center">
          <img
            src={logoSrc}
            alt={companyName}
            style={{
              maxWidth: "200px",
              height: "48px",
              objectFit: "contain",
            }}
          />
        </Link>

        <div className="d-flex align-items-center gap-3">
          {loading && <BeatLoader color="#C6153B" />}

          {settings && settings.facebook_link && (
            <a
              href={settings.facebook_link}
              target="_blank"
               rel="noopener noreferrer"
              title="Facebook"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill={iconColor}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z" />
              </svg>
            </a>
          )}

          {/* Instagram */}
          {settings && settings.instagram_link && (
            <a
              href={settings.instagram_link}
              target="_blank"
               rel="noopener noreferrer"
              title="Instagram"
            >

              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1804_18604)">
                  <path d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z" fill={iconColor}/>
                  <path d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z" fill={iconColor}/>
                  <path d="M19.8469 5.59214C19.8469 6.38902 19.2 7.0312 18.4078 7.0312C17.6109 7.0312 16.9688 6.38433 16.9688 5.59214C16.9688 4.79526 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.79995 19.8469 5.59214Z" fill={iconColor}/>
                </g>
                <defs>
                  <clipPath id="clip0_1804_18604">
                    <rect width="24" height="24" fill={iconColor} />
                  </clipPath>
                </defs>
              </svg>
            </a>
          )}

          {/* TikTok */}
          {settings && settings.tiktok_link && (
            <a
              href={settings.tiktok_link}
              target="_blank"
               rel="noopener noreferrer"
              title="TikTok"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill={iconColor}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z" />
              </svg>
            </a>
          )}

          {/* Website */}
          {settings && settings.web_link && (
            <a
              href={settings.web_link}
              target="_blank"
               rel="noopener noreferrer"
              title="Website"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke={iconColor}
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22M2.5 9H21.5M2.5 15H21.5" />
              </svg>

            </a>


          )}
        </div>
      </div>
    </nav>
  );
}

export default EventNavbar;
